import { RootState } from "../../../store";
import { ResourceType } from "../../../../services/cloudchipr.api";
import { resourceTypeDataSelector } from "../../../account/selectors/resource-type-data/resourceTypeDataSelector";
import { ResourceDataType } from "../../../account/utils/types/types";

export const liveFilteredResourcesSelector = (
  state: RootState,
  resourceType: ResourceType,
): ResourceDataType[] | undefined => {
  return resourceTypeDataSelector(state, resourceType)?.resources;
};
